<div class="p-0 flex justify-center items-center h-full w-full">
  <div class="grow flex flex-col w-full h-full max-w-[600px]">
    <!-- Navbar -->
    <div class="p-4 block sm:hidden">
      <mat-icon (click)="onHamburgerClick.emit()">arrow_back</mat-icon>
    </div>
    <div class="grow flex flex-col justify-between items-center w-full h-full">
      <input hidden type="text" [formControl]="amountFormControl" />

      <!-- Date picker -->

      <input
        matInput
        hidden
        [matDatepicker]="picker"
        [formControl]="dateFormControl"
      />
      <mat-datepicker #picker touchUi></mat-datepicker>

      <!-- Preview -->
      <div
        class="grow flex flex-col grow shrink-0 justify-center items-center mb-8"
      >
        <div class="meta">
          <span *ngIf="memo">{{ memo }} on </span
          >{{ dateFormControl.value | date }}
        </div>
        <!-- Amount display -->
        <div
          [hidden]="!amountFormControl.value || amountFormControl.value === '0'"
          class="amount"
          [ngClass]="{
            '!text-red-500': isNegative && hasAmount(),
            '!text-green-500': !isNegative && hasAmount()
          }"
          (click)="isNegative = !isNegative"
        >
          <span class="text-red-500" [hidden]="!isNegative || !hasAmount()"
            >-</span
          >
          <span class="text-green-500" [hidden]="isNegative || !hasAmount()"
            >+</span
          >
          <span>{{
            getAsNumber(amountFormControl.value) | prefundCurrency
          }}</span>
        </div>
        <div
          [hidden]="amountFormControl.value && amountFormControl.value !== '0'"
          class="amount text-gray-300"
        >
          0
        </div>

        <!-- Memo and Date -->
        <div class="flex flex-col items-center">
          <span
            *ngFor="
              let tag of tagSelectionService.selectedTags | slice : 0 : 3;
              index as i;
              trackBy: trackByTagId
            "
            class="mb-2 tag {{ tag?.color }}"
          >
            #{{ tag?.fullPath }}
          </span>
          <span class="tag" *ngIf="tagSelectionService.selectedTags.length > 3"
            >+{{ tagSelectionService.selectedTags.length - 3 }}</span
          >
        </div>
      </div>
      <!-- Numpad -->
      <div class="w-full p-2 grow shrink-0">
        <div class="flex flex-col justify-between h-full">
          <!-- First row -->
          <div class="flex grow shrink-0">
            <div class="dialer-button numeric grow shrink-0" (click)="type(1)">
              1
            </div>
            <div class="dialer-button numeric grow shrink-0" (click)="type(2)">
              2
            </div>
            <div class="dialer-button numeric grow shrink-0" (click)="type(3)">
              3
            </div>
            <div
              class="dialer-button grow shrink-0"
              (click)="openBottomSheet()"
            >
              <mat-icon>tag</mat-icon>
            </div>
          </div>
          <div class="flex grow shrink-0">
            <div class="dialer-button numeric grow shrink-0" (click)="type(4)">
              4
            </div>
            <div class="dialer-button numeric grow shrink-0" (click)="type(5)">
              5
            </div>
            <div class="dialer-button numeric grow shrink-0" (click)="type(6)">
              6
            </div>
            <div class="dialer-button grow shrink-0" (click)="picker.open()">
              <mat-icon>calendar_today</mat-icon>
            </div>
          </div>
          <div class="flex grow shrink-0">
            <div class="dialer-button numeric grow shrink-0" (click)="type(7)">
              7
            </div>
            <div class="dialer-button numeric grow shrink-0" (click)="type(8)">
              8
            </div>
            <div class="dialer-button numeric grow shrink-0" (click)="type(9)">
              9
            </div>
            <div class="dialer-button grow shrink-0" (click)="addMemo()">
              <mat-icon>notes</mat-icon>
            </div>
          </div>
          <div class="flex grow shrink-0">
            <div class="dialer-button grow shrink-0" (click)="backspace()">
              <mat-icon>backspace</mat-icon>
            </div>
            <div class="dialer-button numeric grow shrink-0" (click)="type(0)">
              0
            </div>
            <div class="dialer-button grow shrink-0" (click)="decimal()">.</div>
            <div
              class="dialer-button grow shrink-0 !bg-[var(--primary-color)]"
              (click)="submit()"
            >
              <mat-icon>check_circle</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
